

import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ModalWrapper from 'components/ModalWrapper'
import { useTranslation } from "react-i18next";
import SectionWrapper from "components/wrappers/SectionWrapper";
import Input from "components/forms/Input";
import { BiEditAlt } from 'react-icons/bi'
import Language from "components/Language";
import PropTypes from 'prop-types';

const EditCategory = ({ disabled, onUpdate, data }) => {

    const { t } = useTranslation();

    const { register, handleSubmit, formState: { errors } } = useForm();

    const [isOpen, setIsOpen] = useState(false);

    useEffect(() => {
    }, [isOpen])

    const onSubmit = (data) => {
        onUpdate(data)
        setIsOpen(false)
    }

    return (
        <>
            <button disabled={!!disabled}
                className={`capitalize focus:outline-none focus:ring-2 focus:ring-offset-2  transition duration-150 ease-in-out 
              rounded  p-2 text-xl ${disabled ? 'bg-gray-200 text-gray-400' : '  focus:ring-gray-200 hover:bg-gray-100'}`}
                onClick={() => setIsOpen(true)}>
                <BiEditAlt />
            </button>

            <ModalWrapper
                open={isOpen}
                setOpen={setIsOpen}
                title={t('actions.edit') + " " + t('form.category')}
            >
                <form className="w-[480px]  lg:w-[720px]" onSubmit={handleSubmit(onSubmit)}>
                    <SectionWrapper
                        title={t('form.title')}
                    >
                        <Input
                            id="title.french"
                            label={<Language _key="fr"  />}
                            placeholder={t('form.title') + t('form.in') + t('languages.fr')}
                            register={register("title.french", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.title?.french}
                            defaultValue={data?.title.french}
                            className="my-2"

                        />
                        <Input
                            id="title.arabic"
                            label={<Language _key="ar"  />}
                            placeholder={t('form.title') + t('form.in') + t('languages.ar')}
                            register={register("title.arabic", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.title?.arabic}
                            defaultValue={data?.title.arabic}
                            className="my-2"
                        />

                        <Input
                            id="title.english"
                            label={<Language _key="en"  />}
                            placeholder={t('form.title') + t('form.in') + t('languages.en')}
                            register={register("title.english", {
                                required: t('form.missing_field')
                            })}
                            error={errors?.title?.english}
                            defaultValue={data?.title.english}
                            className="my-2"

                        />

                    </SectionWrapper>

                    {/* Actions  */}
                    <div className="justify-end flex items-center mt-8">
                        <input type='button' value={t('actions.cancel')} onClick={() => setIsOpen(false)}
                            className='font-medium  text-sm capitalize bg-gray-100 rounded  px-4 py-2  mx-2 border-1 border-gray-500  cursor-pointer hover:bg-gray-300 shadow'
                        />
                        <input
                            className='capitalize font-medium    text-white bg-blue-500 rounded  px-4 py-2  mx-2 border-1 border-blue-500 shadow-md  cursor-pointer hover:bg-blue-600'
                            type="submit" value={t('actions.update')} />
                    </div>
                </form>
            </ModalWrapper>


        </>

    );

}

export default EditCategory;

EditCategory.propTypes = {
  disabled: PropTypes.bool,
  onUpdate: PropTypes.func.isRequired,
  data: PropTypes.object,
};







